const DATA_TEST_IDS = {
  CLASSES_DROPDOWN_TOGGLE: 'classes-dropdown-toggle',
  ASSIGN_TO_SECTION: 'assign-to-section',
  CHECKBOX_TEXT: 'checkbox-text',
  PROGRESS_SECTIONS: 'progress-sections',
  PROGRESS_SECTION_NAME: 'progress-section-name',
  PROGRESS_LINK: 'progress-link',
  CLASS_DROPDOWN_STUDENT_ELEMENT: 'class-dropdown-student-element',
  SECTION_STUDENTS_CONTAINER: 'section-students-container',
  CHECKBOX_CONTAINER: 'checkbox-container',
  SELECT_ALL_SECTIONS: 'select-all-sections',
  PROGRESS_ISA_NOTATION: 'isa-notation',
  PROGRESS_NAME_CONTAINER: 'progress-name-container',
  SINGLE_CLASS_CONTAINER: '[data-test-id="single-class-container"]',
  INPUT_DEFAULT_VALUE: 'input-default-value',
  SELECT_ALL_STUDENTS: 'select-all-students',
  TIMER_INPUT: 'timer-input',
  DATE_YEARS_MONTH_LABEL: 'date-year-month-label',
  DATE_HOURS_MINUTES_LABEL: 'date-hours-minutes-label',
  DATEPICKER_RESET_BUTTON: 'datepicker-reset-button',
  EMPTY_DATEPICKER: 'datepicker-empty',
  ASSIGNABLE_SECTIONS: 'assignable-sections',
  ASSIGN_DROPDOWN_TOGGLE: 'assign-dropdown-toggle',
  ASSIGN_STUDENT: 'assign-student',
  CLASSES_DROPDOWN_LAST_FOCUSABLE_ELEMENT: 'classes-dropdown-last-focusable',
  CLASSNAME_DROPDOWN_TOGGLE: 'classname-dropdown-toggle',
  STUDENT_INPUT_CHECKBOX: 'student-input-checkbox',
  PLACEHOLDER_TEXT: 'placeholder-text',
  COORDINATOR_INSTRUCTION: 'coordinator-instruction',
  ASSIGN_SUBMIT_BUTTON: 'submit-button',
  ADD_CAS_SETTINGS_BUTTON: 'add-different-custom-setitngs',
  UPDATE_SETTINGS_IS_SOFT_TIMER: 'update-settings-is-soft-timer',
  CAS_SETTINGS_INFO_POPOVER: 'cas-settings-info-popover',
};

export default DATA_TEST_IDS;
